import type { Theme } from '@mui/material/styles';

export const INTERACTION_DURATION = 160;

export const createInteractionTransition = (theme: Theme, properties: string[]) =>
  theme.transitions.create(properties, {
    duration: INTERACTION_DURATION,
    easing: theme.transitions.easing.easeOut,
  });

export const createInteractiveCardSx = (theme: Theme) => ({
  transition: createInteractionTransition(theme, ['transform', 'box-shadow', 'border-color', 'background-color']),
  '@media (hover: hover)': {
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: theme.palette.mode === 'dark'
        ? '0 12px 26px rgba(0, 0, 0, .24)'
        : '0 12px 26px rgba(32, 55, 44, .11)',
    },
  },
  '@media (prefers-reduced-motion: reduce)': {
    transition: 'none',
    '&:hover': { transform: 'none' },
  },
});

export const createSurfaceHoverSx = (theme: Theme) => ({
  transition: createInteractionTransition(theme, ['background-color', 'color']),
  '&:hover': { backgroundColor: theme.palette.action.hover },
  '@media (prefers-reduced-motion: reduce)': { transition: 'none' },
});

export const createTextActionSx = (theme: Theme) => ({
  transition: createInteractionTransition(theme, ['color', 'text-decoration-color']),
  '&:hover': {
    color: theme.palette.primary.dark,
    backgroundColor: 'transparent',
    textDecoration: 'underline',
  },
  '@media (prefers-reduced-motion: reduce)': { transition: 'none' },
});

export const createCustomerNameActionSx = (theme: Theme) => ({
  ...createTextActionSx(theme),
  color: theme.palette.primary.main,
  fontSize: 'inherit',
  fontWeight: 500,
  cursor: 'pointer',
  textDecoration: 'none',
  '&:focus-visible': {
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: 2,
    borderRadius: 2,
    textDecoration: 'underline',
  },
});

export const whatsAppBrandSx = {
  backgroundColor: '#25D366',
  '&:hover': { backgroundColor: '#20BA5A' },
};
